// extracted by mini-css-extract-plugin
export default {"input":"WidgetPhone_input__zG5Gf"};